<template>
  <div class="home">
    <div class="lg:flex min-h-screen ">
      <div class="lg:py-16 py-10 lg:px-24 px-6 w-6/12 hidden lg:block">
        <div>
          <img src="@/assets/images/logo-removebg-preview.png" alt="" />
        </div>
        <div class="lg:pt-24 font-semibold sm:pt-10 text-4xl">
          <h1 class="headd">
            Monitor your <br />
            Most Valuable <br />Assets
          </h1>
        </div>
        <div>
          <p class="text-2xl pt-10">Get Started Now</p>
        </div>
        <div class="-mt-40 flex flex-row-reverse ">
          <img
            src="@/assets/images/MaskGroup59.png"
            alt=""
            class="w-2/4 ballonDance"
          />
        </div>
      </div>
      <div
        class="py-10 lg:py-40 px-5 lg:px-40 homeBackground w-full lg:w-6/12 flex justify-center items-center aaa"
      >
        <div class="w-full">
          <div class="text-center lg:hidden">
            <img
              src="@/assets/images/logo-removebg-preview.png"
              alt=""
              width="200px"
              class="pb-5"
            />
          </div>
          <div
            class="border-0 rounded-lg shadow-lg flex flex-col w-full px-6 md:px-12 bg-white outline-none focus:outline-none"
          >
            <!--header-->
            <div class="flex flex-col py-8 rounded-t">
              <h3 class="text-2xl font-semibold mt-4 text-blue">
                Welcome Back
              </h3>
              <h4 class="text-xl font-semibold mt-4">
                Login to your dashboard
              </h4>
            </div>
            <div>
              <form @submit.prevent="submit">
                <div class="py-8">
                  <p class="text-base text-gray-600">Organizatoin ID</p>
                  <input
                    type="text"
                    class="border-b border-solid border-gray-600 mt-3 w-full outline-none"
                    placeholder="12384749958595"
                    v-model="form.org_id"
                  />
                </div>
                <div class="py-8">
                  <p class="text-base text-gray-600">Username</p>
                  <input
                    class="border-b border-solid border-gray-600 mt-3 w-full outline-none"
                    v-model="form.username"
                    type="text"
                  />
                </div>
                <div class="py-8">
                  <p class="text-base text-gray-600">Password</p>
                  <input
                    class="border-b border-solid border-gray-600 mt-3 w-full outline-none"
                    type="password"
                    v-model="form.password"
                  />
                </div>
                <!--body-->
                <div class="flex justify-around w-full items-center py-5">
                  <label class="inline-flex items-center">
                    <input
                      type="checkbox"
                      class="form-checkbox focus:outline-none h-5 w-5 text-blue"
                      checked
                    /><span class="ml-2 text-gray-700">Remember Me</span>
                  </label>

                  <label class="inline-flex items-center">
                    <input
                      type="checkbox"
                      class="form-checkbox focus:outline-none h-5 w-5 text-blue"
                      checked
                    /><span class="ml-2 text-gray-700">Forget Password</span>
                  </label>
                </div>
                <!--footer-->
                <div class="flex items-center justify-center py-10">
                  <button
                    class="w-full h-16 text-white btn-col border-1 outline hover:border-primary font-bold captalize text-sm px-6 py-1 rounded-lg outline-none focus:outline-none mr-1"
                    type="submit"
                    style="transition: all 0.15s ease"
                  >
                    <i class="fas fa-spin fa-spinner" v-if="loading"></i>
                    {{ loading ? "" : "LOGIN" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// @ is an alias to /src
export default {
  name: "Home",
  components: {},
  data() {
    return {
      loading: false,
      form: {
        username: "",
        password: "",
        org_id: ""
      }
    };
  },
  methods: {
    ...mapActions({
      signIn: "auth/signIn"
    }),
    submit() {
      this.loading = true;
      this.signIn(this.form)
        .then(() => {
          this.$router.push({
            name: "Dashboard"
          });
          this.$toast.open({
            message: "You are logged in",
            position: "top-right",
            type: "success"
          });
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$toast.open({
            message: "Something went wrong. Check your details",
            position: "top-right",
            type: "error"
          });
        });
    }
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user"
    })
  }
};
</script>

<style>
.loginbut {
  color: blue;
  color: red;
}
.homeBackground {
  background: url("../assets/images/the-background.png");
  background-size: cover;
}
.headd {
  font-size: 2em !important;
}
.ballonDance {
  animation: ImgBounce 2s ease-in-out 0s infinite alternate;
}
.aaa {
  min-height: 100vh;
}
</style>
